export enum PaymentProviderTypes {
  payment24 = 'Przelewy24',
  blueMedia = 'Bluemedia',
  payU = 'PayU',
  payByNet = 'PayByNet',
}
